var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFeatures15(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 42,
    height: 43,
    viewBox: "0 0 42 43",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1196_14280)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M21 35.2197V41.2197M28.5 32.2197V38.2197M13.5 32.2197V38.2197M24.192 10.8867C24.0211 10.3981 23.7022 9.97485 23.2796 9.6759C22.8569 9.37695 22.3517 9.21715 21.834 9.21873H19.899C19.3502 9.22068 18.8214 9.42473 18.4136 9.79191C18.0057 10.1591 17.7474 10.6636 17.688 11.2092C17.6287 11.7548 17.7723 12.3031 18.0916 12.7494C18.411 13.1957 18.8835 13.5088 19.419 13.6287L22.368 14.2767C22.9685 14.4106 23.4986 14.7611 23.857 15.2611C24.2154 15.7612 24.3771 16.3757 24.311 16.9874C24.2449 17.5991 23.9558 18.165 23.4989 18.577C23.0419 18.989 22.4492 19.2181 21.834 19.2207H20.166C19.6483 19.2223 19.1431 19.0625 18.7204 18.7636C18.2978 18.4646 17.9789 18.0414 17.808 17.5527M21 9.21873V6.71973M21 21.7197V19.2207M8.25 14.9697C8.05109 14.9697 7.86032 14.8907 7.71967 14.7501C7.57902 14.6094 7.5 14.4186 7.5 14.2197C7.5 14.0208 7.57902 13.83 7.71967 13.6894C7.86032 13.5487 8.05109 13.4697 8.25 13.4697C8.44891 13.4697 8.63968 13.5487 8.78033 13.6894C8.92098 13.83 9 14.0208 9 14.2197C9 14.4186 8.92098 14.6094 8.78033 14.7501C8.63968 14.8907 8.44891 14.9697 8.25 14.9697ZM33.75 14.9697C33.5511 14.9697 33.3603 14.8907 33.2197 14.7501C33.079 14.6094 33 14.4186 33 14.2197C33 14.0208 33.079 13.83 33.2197 13.6894C33.3603 13.5487 33.5511 13.4697 33.75 13.4697C33.9489 13.4697 34.1397 13.5487 34.2803 13.6894C34.421 13.83 34.5 14.0208 34.5 14.2197C34.5 14.4186 34.421 14.6094 34.2803 14.7501C34.1397 14.8907 33.9489 14.9697 33.75 14.9697Z",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.5 2.21973H4.5C3.70435 2.21973 2.94129 2.5358 2.37868 3.09841C1.81607 3.66102 1.5 4.42408 1.5 5.21973V23.2197C1.5 24.0154 1.81607 24.7784 2.37868 25.341C2.94129 25.9037 3.70435 26.2197 4.5 26.2197H37.5C38.2956 26.2197 39.0587 25.9037 39.6213 25.341C40.1839 24.7784 40.5 24.0154 40.5 23.2197V5.21973C40.5 4.42408 40.1839 3.66102 39.6213 3.09841C39.0587 2.5358 38.2956 2.21973 37.5 2.21973Z",
    stroke: "#006EC2",
    strokeWidth: 3,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1196_14280"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 42,
    height: 42,
    fill: "white",
    transform: "translate(0 0.719727)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFeatures15);
export default __webpack_public_path__ + "static/media/features15.29fe430cc9582e85e1e69b4d379eb1f6.svg";
export { ForwardRef as ReactComponent };